import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, INK, Reveal, Title } from '../components/deck/Type';
import { productShots } from '../data/ecosystem';
const groups = [{
  tone: INK.blue,
  name: 'Intake',
  items: 'Deal intake · Data-room ingestion · Thesis-fit scoring'
}, {
  tone: INK.violet,
  name: 'Analysis',
  items: 'Data sufficiency · Market intelligence · Business risk · Comparables · Financials'
}, {
  tone: INK.gold,
  name: 'Output',
  items: 'Structured tear sheets · Investment memos · Source citations'
}, {
  tone: INK.emerald,
  name: 'Decide & learn',
  items: 'Team review and voting · Portfolio monitoring · LP reporting'
}];
const rail = ['Upload', 'Structure', 'Analyze', 'Decide', 'Learn'];
export function ProductExperienceSlide() {
  return <Slide index={6} data-id="element-216" data-mp="2a8irno5yxve6">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-217" data-mp="25binjisoj2pp">
        <div className="max-w-[64%]" data-id="element-218" data-mp="25dd6irke4kr5">
          <Eyebrow data-id="element-219" data-mp="2nh9xx1t8302n">Product experience</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-220" data-mp="2nil232qky9ua">
            From raw startup data to investment conviction in one workspace.
          </Title>
        </div>
        <div className="flex items-center gap-[1vw]" data-id="element-221" data-mp="2whyads2ywsdf">
          {rail.map((r, i) => <React.Fragment key={r} data-id="element-222" data-mp="31grsjxt797jx" data-mpi={i}>
              {i > 0 && <span className="text-white/25" data-id="element-223" data-mp="31hkqc9a6kmpx">→</span>}
              <span className="text-[clamp(8px,0.84vw,17px)] uppercase tracking-[0.18em] text-[#8B95A8]" data-id="element-224" data-mp="36fw2iqny79bb">
                {r}
              </span>
            </React.Fragment>)}
        </div>
      </div>

      <div className="mt-[3vh] grid min-h-0 flex-1 grid-cols-[72%_1fr] gap-[2.4vw]" data-id="element-225" data-mp="3g55rvyreqdvq">
        <Reveal delay={0.1} className="flex min-h-0 items-start" data-id="element-226" data-mp="3k79dhg7siyuq">
          <img src={productShots.dealAnalysis} alt="DiligenceGPT deal analysis workspace showing deal fit score, gap analysis, market intelligence and business risk reports" className="max-h-full w-full border border-white/12 object-contain object-top" data-id="element-227" data-mp="3k6hia6i3v34z" />
        </Reveal>

        <div className="flex min-h-0 flex-col justify-between" data-id="element-228" data-mp="1u0uqt100xfkw">
          {groups.map((g, i) => <Reveal key={g.name} delay={0.12 + i * 0.07} data-id="element-229" data-mp="1p29uvdrt1i29" data-mpi={i}>
              <div className="flex items-center gap-[0.7vw]" data-id="element-230" data-mp="23tsd7i84zoos">
                <span className="h-[0.9vh] w-[0.9vh] rounded-full" style={{
              background: g.tone
            }} data-id="element-231" data-mp="1z1saji0omhoi" />
                <span className="text-[clamp(8px,0.84vw,17px)] uppercase tracking-[0.22em]" style={{
              color: g.tone
            }} data-id="element-232" data-mp="2crvrpukpfl73">
                  {g.name}
                </span>
              </div>
              <Caption className="mt-[0.9vh]" data-id="element-233" data-mp="2ht1lzwu0jgiq">{g.items}</Caption>
            </Reveal>)}
        </div>
      </div>
    </Slide>;
}